import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { TodoProjectResponse } from '@/lib/api';
import { resolveProjectColor } from '../lib/projectColors';

/** Small colored chip showing a task's project — at-a-glance in the section view. */
export function ProjectChip({
  project,
  className,
}: {
  project: TodoProjectResponse;
  className?: string;
}) {
  const color = resolveProjectColor(project.color);
  return (
    <Badge
      variant="outline"
      className={cn('flex-shrink-0 gap-1 border-0 px-1.5 py-0 text-[10px]', color.chip, className)}
      title={`Project: ${project.name}`}
    >
      <span className={cn('h-1.5 w-1.5 flex-shrink-0 rounded-full', color.dot)} />
      <span className="max-w-[8rem] truncate">{project.name}</span>
    </Badge>
  );
}
